import {App} from './App';
import features = require('diy/util/features');

import {IframeContext} from 'diy/site-admin/main/IframeContext';
import ColorUtil from "diy/util/color";

import {AppsIntegration} from 'diy/external/AppsIntegration';

import sectionsWeb = require('./module/section/web/index');

declare var diy: any;

export class Api {
    constructor(private app: App) {
    }

    init() {
        // Used by trialLayer.
        // TODO: remove namespace when api.js and trialLayer.js are migrated to webpack
        diy.appUpsell = require('diy/app-upsell/appUpsell');

        diy.core.namespace('diy.help').callback = require('./help/callback/callback');

        // Expose Semantic data api to APPS SDK
        diy.core.namespace('diy.editor.semanticdata').api = require('./semanticdata/api/api');

        diy.core.namespace('diy.util').color = ColorUtil;

        Object.assign(diy.core.namespace('diy.editor'), {
            // Tariff update
            // TODO: remove this namespace when UpgradeLayer.js is migrated to webpack
            tariffUpdate: require('./tariffupdate/tariffUpdate'),

            // Expose apps catalog to APPS SDK and non-webpack code
            appsCatalog: require('diy/site-admin/apps-catalog/appsCatalog'),

            // Expose to non-webpack code
            deeplinking: require('diy/util/deeplinking'),

            // Expose facebook app id to non-webpack code
            getFacebookAppId: require('diy/social/FacebookAppId')
        });

        Object.assign(diy.core.namespace('diy.editor.siteadmin'), {
            api: require('diy/site-admin/main/api')
        });

        Object.assign(diy.core.namespace('diy.editor.siteadmin.controllers'), {
            // Expose legacy objects for non-webpack code
            guidedSetup: require('diy/site-admin/main/controllers/guidedSetup'),
            appsCatalog: require('diy/site-admin/main/controllers/appsCatalog'),
            layoutSelector: require('diy/site-admin/main/controllers/layoutSelector'),
            theming: require('diy/site-admin/main/controllers/theming'),
            moduleSelector: require('diy/site-admin/main/controllers/moduleSelector'),
            pagesEditor: require('diy/site-admin/main/controllers/pagesEditor'),
            showroom: require('diy/site-admin/main/controllers/showroom'),
            sectionSelector: require('diy/site-admin/main/controllers/sectionSelector'),
            onboardingGuide: require('diy/site-admin/main/controllers/onboardingGuide'),
            fbpb: require('diy/site-admin/main/controllers/fbpb')
        });

        if (features('apps')) {
            // Expose to SDK
            diy.editor.appsIntegration = new AppsIntegration();
        }

        if (features('appsExtensionPoint')) {
            let appExtensionPoint = require('diy/site-admin/main/controllers/appExtensionPoint');
            diy.editor.siteadmin.controllers.appExtensionPoint = appExtensionPoint;
        }

        // Context object for siteadmin iframe (exports API from main window)
        let iframeContext = new IframeContext(this.app);
        diy.editor.siteadmin.exportContext = () => iframeContext.export();

        diy.core.namespace('diy.module.section').initWeb = sectionsWeb.initWeb;
    }

    initUndoRedoApi(undoRedo: any) {
        diy.editor.undoRedo = undoRedo;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/Api.ts
 **/